// extracted by mini-css-extract-plugin
export var aiGlow = "_1g-2";
export var aiGlowFocus = "_1g-1";
export var aiGlowHover = "_1g-0";
export var glowRotate = "_1g-3";